import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP2MedianNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p2_median_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 2711,
  clicks: 34,
  adsSpendDollars: 142,
  budgetDollars: 300,
  salesDollars: 1479,
  bestEstimateRoas: 10.42,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.47,
  newCustomersAcquired: 2,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
